// Google Analytics 4 utility
// Replace G-XXXXXXXXXX with your real Measurement ID in .env:
//   NEXT_PUBLIC_GA_MEASUREMENT_ID=G-XXXXXXXXXX

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

/**
 * Send a custom event to GA4.
 * Works in both development (logs to console) and production (sends to GA).
 */
export function trackEvent(
  eventName: string,
  eventParams: Record<string, unknown> = {}
): void {
  if (typeof window === 'undefined') return;

  if (process.env.NODE_ENV !== 'production') {
    // Dev mode: log to console so you can verify events without polluting GA
    console.log('[GA4 Event]', eventName, eventParams);
    return;
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

/** Track a page view (called automatically via GA4 config, but exposed for manual use) */
export function trackPageView(url: string): void {
  trackEvent('page_view', { page_path: url });
}

/** Track tab switch between ID Share 01 / ID Share 02 */
export function trackTabSwitch(toTab: 1 | 2): void {
  trackEvent('tab_switch', {
    tab_label: `ID Share 0${toTab}`,
    tab_index: toTab,
  });
}

/** Track copy button click (account or password) */
export function trackCopyClick(label: string, region?: string): void {
  trackEvent('copy_button_click', {
    copy_type: label,
    region: region ?? 'unknown',
  });
}
